import React, { useState } from "react";

export default function FaqComp() {
  const [active, setActive] = useState(0);

  const faqs = [
    {
      id: "01",
      question: "Apakah bisa custom tema sesuai keinginan saya?",
      answer:
        "Iya, tentu bisa! Kamu dapat membuat undangan digital secara full custom mulai dari desain, warna, teks hingga elemen visual lainnya sesuai kebutuhan acara kamu.",
    },
    {
      id: "02",
      question:
        "Bagaimana jika saya ada kendala dalam penggunaan aplikasi?",
      answer:
        "Tim kami akan senang hati membantu jika ada kendala, tombol bantuan hadir selalu didalam aplikasi",
    },
    {
      id: "03",
      question:
        "Bagaimana Aplikasi idinvitebook bekerja",
      answer:
        "Cukup pilih tema , edit data sesuai pesanan , share link hasil ke calon customer",
    },
    {
      id: "04",
      question: "Bagaimana ketentuan pembayaran di idinvitebook?",
      answer:
        "Pembayaran dilakukan melalui transfer bank CS atau halaman pricing pada aplikasi. ada 2 tipe paket lifetime dan tahunan",
    },
    {
      id: "05",
      question: "Apakah undangan bisa diakses di semua perangkat?",
      answer:
        "Ya, undangan dapat dibuka di smartphone, tablet, maupun desktop dengan tampilan responsif.",
    },
    {
      id: "06",
      question: "Kapan saya bisa menghubungi idinvitebook?",
      answer:
        "Kami siap membantu setiap hari melalui WhatsApp maupun media sosial resmi.",
    },
  ];

  return (
    <div className="faq-section">
      <div className="heading">
        <h1>Pertanyaan Umum (FAQ)</h1>
        <p>
          Temukan jawaban untuk pertanyaan yang sering diajukan tentang layanan
          kami
        </p>
      </div>

      <div className="faq-grid">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-card ${active === index ? "active" : ""}`}
            onClick={() =>
              setActive(active === index ? null : index)
            }
          >
            <div className="faq-top">
              <div className="faq-number">{faq.id}</div>

              <h2>{faq.question}</h2>

              <button className="faq-btn">
                {active === index ? "−" : "+"}
              </button>
            </div>

            <div
              className={`faq-answer ${
                active === index ? "show" : ""
              }`}
            >
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      <style>{`
        *{
          margin:0;
          padding:0;
          box-sizing:border-box;
        }

        body{
          font-family:Arial, sans-serif;
          background:#f8f7f8;
        }

        .faq-section{
          width:100%;
          padding:20px 5%;
          background:#f8f7f8;
        }

        .heading{
          text-align:center;
          margin-bottom:60px;
        }

        .heading h1{
          font-size:72px;
          font-weight:600;
          color:#43384a;
          margin-bottom:14px;
          line-height:1;
        }

        .heading p{
          color:#7d7583;
          font-size:18px;
        }

        .faq-grid{
          display:grid;
          grid-template-columns:1fr 1fr;
          gap:24px;
          align-items:start;
        }

        .faq-card{
          background:white;
          border:1px solid #ece7eb;
          border-radius:24px;
          padding:34px;
          cursor:pointer;
          transition:0.35s ease;
        }

        .faq-card:hover{
          transform:translateY(-4px);
          box-shadow:0 10px 30px rgba(0,0,0,0.05);
        }

        .faq-top{
          display:flex;
          align-items:flex-start;
          gap:24px;
        }

        .faq-number{
          font-size:24px;
          font-weight:600;
          color:#ff0a8a;
          min-width:42px;
        }

        .faq-top h2{
          flex:1;
          font-size:28px;
          line-height:1.35;
          color:#4a3d4d;
          font-weight:600;
        }

        .faq-btn{
          width:48px;
          height:48px;
          min-width:48px;
          border:none;
          border-radius:50%;
          background:#ff0a8a;
          color:white;
          font-size:30px;
          cursor:pointer;
          display:flex;
          align-items:center;
          justify-content:center;
        }

        .faq-card.active .faq-btn{
          background:#ffe4f2;
          color:#ff0a8a;
        }

        .faq-answer{
          max-height:0;
          overflow:hidden;
          transition:all 0.4s ease;
          padding-left:66px;
        }

        .faq-answer.show{
          max-height:300px;
          margin-top:24px;
        }

        .faq-answer p{
          font-size:18px;
          line-height:1.8;
          color:#746d78;
        }

        @media(max-width:992px){

          .heading h1{
            font-size:52px;
          }

          .faq-grid{
            grid-template-columns:1fr;
          }
        }

        @media(max-width:768px){

          .faq-section{
            padding:60px 20px;
          }

          .heading{
            margin-bottom:40px;
          }

          .heading h1{
            font-size:38px;
            line-height:1.2;
          }

          .heading p{
            font-size:15px;
          }

          .faq-card{
            padding:24px;
            border-radius:20px;
          }

          .faq-top{
            gap:16px;
          }

          .faq-number{
            font-size:20px;
            min-width:32px;
          }

          .faq-top h2{
            font-size:24px;
          }

          .faq-btn{
            width:42px;
            height:42px;
            min-width:42px;
            font-size:24px;
          }

          .faq-answer{
            padding-left:48px;
          }

          .faq-answer p{
            font-size:16px;
            line-height:1.7;
          }
        }
      `}</style>
    </div>
  );
}